// @flow strict

/**
 * Common schemas and utility functions related to JSON Schema
 * @module util/schema
 */

/** A JSONSchema definition for a Double */
export const DoubleSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'number',
  multipleOf: 0.01
}

/** A JSONSchema definition for a UUID */
export const UUIDSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'string',
  minimum: 1
}

/** A JSONSchema definition for a StringList */
export const StringListSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    id: {
      type: 'array',
      items: {
        type: 'string'
      }
    }
  },
  additionalProperties: false
}
